"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDataTapes = void 0;
const consts_1 = require("../consts");
const typeguards_1 = require("../typeguards");
const validateDataTapes = ({ dataTapeDependencies, dataTapes, }) => {
    // ensure that there are no duplicate uuids in dataTapes
    const errorMessages = [];
    const dataTapeIds = dataTapes.map(({ id }) => id);
    const uniqueDataTapeIds = new Set(dataTapeIds);
    if (dataTapeIds.length !== uniqueDataTapeIds.size) {
        errorMessages.push('Duplicate ids in dataTapes');
    }
    // ensure that dataTapeDependencies reference valid dataTapes
    dataTapeDependencies.forEach(({ inputArtifactId, outputArtifactId }) => {
        const inputTape = dataTapes.find((tape) => tape.id === inputArtifactId);
        const outputTape = dataTapes.find((tape) => tape.id === outputArtifactId);
        if (!inputTape) {
            errorMessages.push(`Invalid inputArtifactId: ${inputArtifactId}`);
        }
        if (!outputTape) {
            errorMessages.push(`Invalid outputArtifactId: ${outputArtifactId}`);
        }
    });
    // for a given tape id, find all the tapes that depend on it
    const getOutputTapes = (tapeId) => {
        return dataTapeDependencies.filter(({ inputArtifactId }) => inputArtifactId === tapeId);
    };
    // for a given tape id, find all the tapes that it depends on
    const getInputTapes = (tapeId) => {
        return dataTapeDependencies.filter(({ outputArtifactId }) => outputArtifactId === tapeId);
    };
    const rawTapes = dataTapes.filter((tape) => (0, consts_1.isRawTapeType)(tape.type));
    const derivedTapes = dataTapes.filter((tape) => (0, consts_1.isDerivedTapeType)(tape.type));
    // raw tapes
    rawTapes.forEach((tape) => {
        // they must not depend on other tapes.
        if (getInputTapes(tape.id).length) {
            errorMessages.push(`Raw tape ${tape.artifactSlug} depends on other tapes`);
        }
        // they must be depended on by at least one tape.
        if (getOutputTapes(tape.id).length === 0) {
            errorMessages.push(`Raw tape ${tape.artifactSlug} is not depended on`);
        }
    });
    // derived Tapes
    derivedTapes.forEach((tape) => {
        // must depend on at least one tape.
        if (getInputTapes(tape.id).length === 0) {
            errorMessages.push(`Derived tape ${tape.artifactSlug} does not depend on any tapes`);
        }
    });
    // validate that dataTapes can be converted into tapeBuilderRecords
    dataTapes.forEach((tape) => {
        // strip out timestamps before validating.
        const result = typeguards_1.typeguards.validateTapeBuilderRecordUI(tape);
        if (!result.isValid) {
            errorMessages.push(`artifactId [:${tape.id}] is invalid: ${result.errorMessages.join(', ')}`);
        }
    });
    return {
        isValid: errorMessages.length === 0,
        errorMessages,
    };
};
exports.validateDataTapes = validateDataTapes;
//# sourceMappingURL=validateDataTapes.js.map